import { Typography, Button } from '@mui/material';
import SimpleDialog from '@/components/ui/SimpleDialog.tsx';
import { useNavigate } from 'react-router-dom';

const SuitabilityTestModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const navigate = useNavigate();

  const handleCompleteSuitability = () => {
    onClose();
    navigate('/test-idoneidad');
  };

  const handleLater = () => {
    onClose();
  };

  return (
    <SimpleDialog
      open={open}
      onClose={handleLater}
      title="Test de Idoneidad necesario"
      actions={
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCompleteSuitability}
            sx={{ minWidth: 140 }}
          >
            Completar ahora
          </Button>
          <Button variant="outlined" onClick={handleLater} sx={{ minWidth: 120 }}>
            Más tarde
          </Button>
        </>
      }
    >
      <Typography variant="body1" sx={{ mb: 1 }}>
        Antes de reservar una oportunidad o colaborar con PSIs necesitamos confirmar que entiendes
        los riesgos de invertir.
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        🕒 &lt; 10 minutos
      </Typography>
    </SimpleDialog>
  );
};

export default SuitabilityTestModal;
